import { Result } from 'domain/types';

import ReadPermissionsClient from 'use-case/permissions/read/readPermissionsClient';
import Permissions from 'domain/entity/permissions';

export type ReadPermissionsResult = Result<Permissions>;
export type ReadPermissions = () => Promise<ReadPermissionsResult>;

export default (readPermissionsClient: ReadPermissionsClient): ReadPermissions => (): Promise<ReadPermissionsResult> =>
    readPermissionsClient();
